import { render, staticRenderFns } from "./permission-form.vue?vue&type=template&id=07cd58fa&"
import script from "./permission-form.vue?vue&type=script&lang=js&"
export * from "./permission-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports